// Apex landing page (M9.3).
//
// Rendered when someone visits `solvait.ai` (no subdomain, no
// `/signup`, no other route). The full marketing site eventually
// lives here; for now this is a minimal "hero + CTA" so the apex
// isn't a 404. The "Sign up" button routes to /signup, which is
// the only customer-facing entry point.

import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export function LandingPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white text-slate-900">
      <header className="border-b border-slate-200/60 bg-white/80 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <div className="flex items-center gap-3">
            <span className="grid h-9 w-9 place-items-center rounded-lg bg-brand-gradient text-white">
              <Sparkles className="h-5 w-5" />
            </span>
            <p className="text-base font-semibold">Solvait-AIHR</p>
          </div>
          <nav>
            <Link
              to="/signup"
              className="rounded-lg bg-brand px-4 py-2 text-sm font-medium text-brand-fg transition hover:opacity-90"
            >
              {t("app.land_signup")}
            </Link>
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-20 text-center">
        <h1 className="text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl">
          {t("app.land_hero")}
        </h1>
        <p className="mt-6 text-lg leading-7 text-slate-600">
          {t("app.land_pitch")}
        </p>
        <div className="mt-10 flex items-center justify-center gap-4">
          <Link
            to="/signup"
            className="rounded-lg bg-brand px-6 py-3 text-base font-medium text-brand-fg shadow-sm transition hover:opacity-90"
          >
            {t("app.land_cta_create")}
          </Link>
          <a
            href="mailto:info@solvait.com?subject=Solvait-AIHR%20enterprise%20demo"
            className="rounded-lg border border-slate-300 px-6 py-3 text-base font-medium text-slate-700 transition hover:bg-slate-100"
          >
            {t("app.land_cta_sales")}
          </a>
        </div>
        <p className="mt-6 text-sm text-slate-500">
          {t("app.land_footnote")}
        </p>
      </main>

      <footer className="mx-auto max-w-6xl px-6 py-10 text-sm text-slate-500">
        {t("app.land_copyright", { year: new Date().getFullYear() })}
      </footer>
    </div>
  );
}
